/**
 * GroupingSelect — Selector plano de Agrupaciones jerárquicas (V1.44)
 * Muestra el árbol de agrupaciones (categories) del kind indicado con sangría por nivel.
 */
import { useEffect, useState } from "react";
import api from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export function flattenGroupTree(items) {
  const children = {};
  const ids = new Set(items.map((i) => i.id));
  items.forEach((c) => {
    const p = c.parent_id && ids.has(c.parent_id) ? c.parent_id : "__root__";
    (children[p] = children[p] || []).push(c);
  });
  Object.values(children).forEach((arr) => arr.sort((a, b) => a.name.localeCompare(b.name, "es")));
  const out = [];
  const walk = (pid, depth) => {
    (children[pid] || []).forEach((c) => {
      out.push({ ...c, depth });
      walk(c.id, depth + 1);
    });
  };
  walk("__root__", 0);
  return out;
}

export default function GroupingSelect({ kind, value, onChange, testId = "grouping-select", placeholder = "Sin agrupación", reloadKey = 0 }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/categories", { params: { kind } }).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [kind, reloadKey]);
  const flat = flattenGroupTree(items.filter((c) => c.active !== false));
  return (
    <Select value={value || "__none__"} onValueChange={(v) => onChange(v === "__none__" ? null : v)}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">Sin agrupación</SelectItem>
        {flat.map((c) => (
          <SelectItem key={c.id} value={c.id}>
            {"\u00A0\u00A0\u00A0".repeat(c.depth)}{c.depth > 0 ? "└ " : ""}{c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
